import { render, staticRenderFns } from "./RelatedArticleCard.vue?vue&type=template&id=3c45987d&scoped=true&lang=pug&"
import script from "./RelatedArticleCard.vue?vue&type=script&lang=js&"
export * from "./RelatedArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticleCard.vue?vue&type=style&index=0&id=3c45987d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45987d",
  null
  
)

export default component.exports